export const source = [
    {
        'name': 'Решение различных практических задач',  
    },
    {
        'name': 'Гидравлические исследования и прогнозирование',
    },
    {
        'name': 'Выявление причин деформаций',
    },
    {
        'name': 'Подбор оптимальных условий эксплуатации сооружений и др.',
    },
    {
        'name': 'Расчёты устойчивости ГТС',
    },
    {
        'name': 'Расчётное обоснование постановки судна к причальному сооружению',
    },
    {
        'name': 'Расчёты, связанные с заменой портальных кранов',
    }
]
 export const options = {
    'isButton': true,
    'description' : 'Все работы проводятся с использованием технической профильной литературы, а также действующих нормативных документов.'
}